import { FC, Fragment } from 'react';
import FRMSiteVisitReportDetailAttendee from './SiteReportPage.Detail.Attendee';
import FRMSiteVisitReportDetailForm from './SiteReportPage.Detail.Form';

const FRMSiteVisitReportDetail: FC = () => {
	return (
		<Fragment>
			<FRMSiteVisitReportDetailAttendee />
			<FRMSiteVisitReportDetailForm />
		</Fragment>
	);
};

export default FRMSiteVisitReportDetail;
